import React, { useContext, useEffect, useState } from "react";
import "./AdvanceDashboard.css";
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";
import Dashboard_LineChart from "./Dashboard_LineChart/Dashboard_LineChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendUp,
  faCartFlatbed,
  faChartSimple,
  faCircleUser,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import { Context } from "../../../utils/context";
import { RoleId } from "../../../utils/common";

function AdvanceDashboard() {
  const navigate = useNavigate();
  const { getData } = useContext(Context);

  const [statusCounts, setStatusCounts] = useState({});
  const [chartData, setChartData] = useState({});
  const [doctor, setDoctor] = useState({});
  const [user, setUser] = useState({});

  // ---------------- API ----------------
  const getDataAll = async () => {
    const result = await getData("/admin/dashboard/dashboard-data");
    setStatusCounts(result?.data);
  };

  const getChartData = async () => {
    const result = await getData("/admin/dashboard/sales-chart");
    setChartData(result.data);
  };

  const getDataDoctor = async () => {
    const result = await getData("/admin/dashboard/doctor-wallet");
    setDoctor(result?.data);
  };

  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };

  useEffect(() => {
    getDataAll();
    getChartData();
    GetUser();
    getDataDoctor();
  }, []);

  // ---------------- COMMON CARD ----------------
  const DashboardCard = ({ title, icon, label, value, onClick }) => (
    <div className="bucket-card-holder" onClick={onClick}>
      <div className="second_card_holder">
        <h6 className="title">{title}</h6>

        <div className="inner_div">
          <div className="top_heading">
            <div className="icon_holder">
              <FontAwesomeIcon className="icon" icon={icon} />
            </div>

            <div className="text_holder">
              <p className="text">{label}</p>
            </div>
          </div>

          <div className="count_holder">
            <p className="count">{value}</p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="main-advancedashboard">
      <section className="AdvanceDashboard">
        <div className="AdvanceDashboardTabs">
          <Header title={"Dashboard"} />
        </div>
      </section>

      {/* ================= DOCTOR ================= */}
      {user.role_id === RoleId.Doctor && (
        <div className="Main-Section-Advanced-Dashboard">
          <div className="row">
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Wallet Amount"
                icon={faWallet}
                label="Wallet Amount"
                value={doctor?.wallet?.amount}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Appointment"
                icon={faCircleUser}
                label="Appointment"
                value={doctor?.appointment?.length}
                onClick={() => navigate("/subscription/appointment")}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Doctor Code"
                icon={faCircleUser}
                label="Doctor Code"
                value={doctor?.doctor?.doctor_code}
              />
            </div>
          </div>
        </div>
      )}

      {/* ================= ADMIN ================= */}
      {user.role_id === RoleId.Admin && (
        <div className="Main-Section-Advanced-Dashboard">
          <div className="row">

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Products"
                icon={faChartSimple}
                label="Total Products"
                value={statusCounts?.total_products}
                onClick={() =>
                  navigate(
                    user?.Store_Detail?.s_category?.is_restaurant_flow
                      ? "/Foods/:id"
                      : "/products"
                  )
                }
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Stock"
                icon={faArrowTrendUp}
                label="Product Stock"
                value=""
                onClick={() => navigate("/product/product-stock")}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Customer Feedback"
                icon={faUser}
                label="Total Messages"
                value={statusCounts?.total_reviews || 0}
                onClick={() => navigate("/product/ratings/:id")}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Today's Payment"
                icon={faWallet}
                label="Total"
                value={statusCounts?.todays_total}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <DashboardCard
                title="Total Customer"
                icon={faUser}
                label="Customers"
                value={statusCounts?.TotalCustomer}
                onClick={() => navigate("/customers")}
              />
            </div>

          </div>

          {/* SALES */}
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="bucket-card-holder">
                <div className="second_card_holder">
                  <h6 className="title">Sales</h6>

                  <div className="inner_div">
                    <div className="top_heading">
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          className="icon"
                          icon={faChartSimple}
                        />
                      </div>
                      <div className="text_holder">
                        <p className="text">This Month</p>
                      </div>
                    <div className="count_holder">
                      <p className="count">{chartData?.total}</p>
                    </div>
                    <div className="card-chart-holder">
                      <Dashboard_LineChart chartData={chartData?.data} />
                    </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>

            {/* ORDERS */}
            <div className="col-md-6">
              <div
                className="bucket-card-holder"
                onClick={() => navigate("/orders/all-orders")}
              >
                <div className="second_card_holder">
                  <h6 className="title">Today's Orders</h6>

                  <div className="inner_div">
                    <div className="top_heading">
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          className="icon"
                          icon={faCartFlatbed}
                        />
                      </div>
                      <div className="text_holder">
                        <p className="text">Today Count</p>
                      </div>
                    <div className="count_holder">
                      <p className="count">
                        {statusCounts?.total_Orders}
                      </p>
                    </div>

                    <div className="table_holder">
                      <Table className="mb-0">
                        <tbody>
                          <tr>
                            <td>Processing</td>
                            <td>{statusCounts?.Processing_orders}</td>
                          </tr>
                          <tr>
                            <td>Preparing</td>
                            <td>{statusCounts?.Preparing}</td>
                          </tr>
                          <tr>
                            <td>Quality Check</td>
                            <td>
                              {statusCounts?.OrderUnderQualityCheck}
                            </td>
                          </tr>
                          <tr>
                            <td>Delivered</td>
                            <td>{statusCounts?.Delivered_orders}</td>
                          </tr>
                          {/* <tr> */}
                            {/* <td>Cancelled</td>
                            <td>{statusCounts?.Cancelled_orders}</td>
                          </tr> */}
                          <tr>
                            <td>Rejected</td>
                            <td>{statusCounts?.Rejected_orders}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default AdvanceDashboard;